import { Box } from '@mui/material';
import { MyMDataGrid } from '../ui-elements/MyMDataGrid';
import { Pager } from '../ui-parts/Pager';

export const PagingDataGrid = (props) => {
  const {
    columns,
    dataList,
    handleSortModelChange,
    isLoading,
    uniquyKey,
    resultListItem,
    handlePageChange,
    labelList,
    messageList,
    pageNumber,
    ...other } = props;

  const CustomNoRowsOverlay = () => {
    return (
      <Box sx={{ textAlign: "center", height: "104px", lineHeight: "104px", fontSize: "1rem" }}>
        {messageList.MyM_MSG_I_0023}
      </Box>
    )
  }

  return (
    <>
      <MyMDataGrid
        columns={columns}
        dataList={dataList}
        uniquyKey={uniquyKey}
        handleSortModelChange={handleSortModelChange}
        isLoading={isLoading}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
        {...other}
      />
      <Pager
        resultListItem={resultListItem}
        handleChangePage={handlePageChange}
        labelList={labelList}
        pageNumber={pageNumber}
      />
    </>
  );
};